import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import './assets/css/reset.css'
import './assets/css/transition.css'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/ui/element.js'
import echarts from 'echarts'
import less from 'less'
import VueSession from 'vue-session'
import axios from 'axios'
import myTime from './time.js'

Vue.use(VueSession)
Vue.use(less)

Vue.prototype.$http = axios
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.prototype.$myTime = myTime

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
